let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hKprL")).then(() => parcelRequire('cmt3m'));